import Button from "@mui/material/Button";
import styled from "styled-components";

import {COLOR} from "config/color";

export const RequiredDot = styled("span")({
  color: "white",
  position: "relative",
  left: "5px",
});

export const greyBackgroud = {
  background: COLOR.btnBackground,
  padding: "12px 20px",
  borderRadius: "8px",
  color: "black",
  fontSize: "1.25rem",
  lineHeight: "160%",
  textAlign: "start",
};

export const btnWhiteContainStyle = {
  backgroundImage: "linear-gradient(#514f4f, #0b0b0b)",
  color: "white",
  borderRadius: "4px",
  minWidth: "initial",
};

export const btnWhiteOutlineStyle = {
  border: `1px solid ${COLOR.fontColorGray}`,
  color: COLOR.fontColorGray,
  background: COLOR.fontColorSecondary,
};

export const WhiteButton = styled(Button)(({variant, sx, block}) => ({
  "&.MuiButtonBase-root.MuiButton-root": {
    fontSize: "1.2rem",
    lineHeight: "160%",
    padding: "0.8rem 2.2rem",
    borderRadius: "0px",
    boxShadow: "none",
    fontWeight: "normal",
    width: block ? "100%" : "fit-content",
    ...(variant === "contained" ? btnWhiteContainStyle : btnWhiteOutlineStyle),
    ...sx,
  },
}));

export const btnBlackContainStyle = {
  background: COLOR.fontColorGray,
  minWidth: "140px",
  color: "white",
};

export const btnBlackOutlineStyle = {
  border: "1px solid black",
  color: "black",
  background: COLOR.fontColorSecondary,
};

export const BlackButton = styled(Button)(({variant, sx, block}) => ({
  "&.MuiButton-root": {
    fontSize: "1.2rem",
    lineHeight: "137%",
    borderRadius: "0px",
    boxShadow: "none",
    width: block ? "100%" : "initial",
    fontWeight: "normal",
    ...(variant === "contained" ? btnBlackContainStyle : btnBlackOutlineStyle),
    ...sx,
  },
  "&.MuiButton-root.Mui-disabled": {
    color: COLOR.fontDisabled,
    background: "white",
  },
}));

export const TextFieldStyle = {
  width: "100%",
  "& .MuiInputBase-input, & .MuiSelect-select": greyBackgroud,
  "& .MuiInputBase-input::placeholder, & .MuiInputLabel-root": {
    fontSize: "1.25rem",
    color: "black",
    opacity: "1",
  },
  "& .MuiOutlinedInput-root": {padding: "0px"},
  "& .MuiOutlinedInput-notchedOutline": {
    border: "0px",
  },
  "& .MuiButton-contained": {
    ...btnBlackContainStyle,
    padding: "14px 20px",
    borderRadius: "4px",
  },
  "& .MuiButton-contained[disabled]": {
    opacity: "0.8",
  },
  "& .Mui-error .MuiInputBase-input": {
    border: "1px solid rgb(211, 47, 47)",
  },
  "& button.Mui-disabled": {
    backgroundImage: "none",
    background: "rgb(121, 121, 124, 0.8)!important",
    color: "rgba(256, 256, 256, 0.6)",
  },
  "& .MuiInputBase-input.Mui-disabled, & .MuiFormHelperText-sizeMedium, & .MuiFormHelperText-sizeMedium.Mui-disabled":
    {
      opacity: "0.8",
    },
};

export const ModalContentStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "70vw",
  p: 4,
  outline: "0px",
  background: COLOR.fontColorGray,
  "& .line": {
    height: "1px",
    background: "white",
    width: "45px",
    margin: "15px auto",
  },
  "& .MuiTextField-root": {
    background: "#fff",
    borderRadius: 0,
    width: "100%",
  },
};

export const ModalStyle = {
  ...ModalContentStyle,
  "& button": {
    width: "100%",
    marginTop: "20px",
    border: "0px",
    color: COLOR.fontColorGray,
  },
};
